import api from '@/lib/api';
import { EptaIntegrationConfig, EptaIntegrationStatus, EptaTestResult } from '../types/epta';

interface ApiEnvelope<T> {
  success: boolean;
  data?: T;
}

export const eptaApi = {
  async getIntegration(clientId: number): Promise<EptaIntegrationStatus | null> {
    try {
      const r = await api.get<ApiEnvelope<EptaIntegrationStatus>>(`/epta/integration/${clientId}`);
      return r.data ?? null;
    } catch (err: unknown) {
      // apiFetch lança ao ver !response.ok; checamos status 404 para distinguir
      const e = err as { message?: string; status?: number } | undefined;
      const msg = String(e?.message ?? '');
      if (msg.includes('404') || e?.status === 404) return null;
      throw err;
    }
  },

  async saveIntegration(clientId: number, cfg: EptaIntegrationConfig): Promise<void> {
    await api.put(`/epta/integration/${clientId}`, cfg);
  },

  async testConnection(
    clientId: number,
    params?: { base_url?: string; token?: string }
  ): Promise<EptaTestResult> {
    const r = await api.post<EptaTestResult>(`/epta/integration/${clientId}/test`, params ?? {});
    return r;
  },

  async deactivate(clientId: number): Promise<void> {
    await api.delete(`/epta/integration/${clientId}`);
  },
};
